import React from "react";

import { ElementState, Preview } from "@creatomate/preview";

import { NumberField } from "@culturehq/components";
import { Trans } from "app/utils";

interface OpacityProps {
  activeElement: ElementState;
  preview: Preview;
}

const Opacity: React.FC<OpacityProps> = ({
  activeElement,
  preview
}) => {
  const handleOpacityChange = async (value: string) => {
    const opacity = +value;
    if (opacity >= 0 && opacity <= 100) {
      await preview.applyModifications({
        [`${activeElement.source.id}.opacity`]: opacity
      });
    }
  };

  return (
    <NumberField
      className="chq-ffd-opacity"
      name="opacity"
      max={100}
      min={0}
      value={activeElement.source.opacity?.replace("%", "") || "100"}
      onChange={handleOpacityChange}
    >
      <Trans>Opacity</Trans>
    </NumberField>
  );
};

export default Opacity;
